export var slice = [].slice;



//////////////////
// WEBPACK FOOTER
// /Users/pakornduangtrakan/Snocko/other/backend-auto/node_modules/d3-queue/src/array.js
// module id = ../../../../d3-queue/src/array.js
// module chunks = common